import { useEffect, useState } from "react";

import { useLikesQuery } from "queries";

export const useLikedGifs = (): string[] => {
  const [ids, setIds] = useState<string[]>([]);
  const { status, data } = useLikesQuery();

  useEffect(() => {
    if (status === "success") {
      setIds(data);
    }
  }, [status, data]);

  return ids;
};
